/**
 * Send the contact form data
 */
window.contactar = function (event) {
    event.preventDefault();
    cleanFeedback('contacto', 'contactoFormulario');

    let formData = new FormData(event.target);

    // Procesamos Recaptcha de Google
    appendGRecaptchaResponse(formData, recaptcha_actions.contact).then(function (formData) {

        $.ajax({
            url:         urlContacto,
            type:        'POST',
            data:        formData,
            processData: false,
            contentType: false,
            beforeSend:  function () {
                $('#contactoFormularioBotonEnviar')
                    .prop('disabled', true)
                    .html(`<i class="ri-loader-4-line spinner"></i>${transAccionProcesando}`);
            },
        })
         .done(function (response) {
             $("#contactoExito")
                 .show()
                 .find('span')
                 .text(response.message);
         })
         .fail(function (jqXHR, status, error) {
             if (jqXHR.responseJSON && jqXHR.responseJSON.message) {
                 $('#contactoError')
                     .show()
                     .find('span')
                     .html(jqXHR.responseJSON.message);
             } else {
                 showInvalidFeedback(jqXHR, 'contacto', 'contactoFormulario');
             }
         })
         .always(function () {
             $("#contactoFormularioBotonEnviar").prop('disabled', false);
             $("#contactoFormularioBotonEnviar").html(`<i class="ri-send-plane-2-fill me-2"></i> ${transAccionEnviar}`);
         });
    }) .catch(function () {
        $("#contactoError")
            .show()
            .find("span")
            .text(transGRecaptchaErrorNotValidated);
    });
}
